import { type RootContainerProps } from "@client/content/types";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import Component, { type MapProps } from "./component";

type Props = RootContainerProps & {};

const makeMapStateToProps = () => {
  const commentFieldSelector = getSettingValueSelector(TargetSelector.Entity, "commentField");

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      isVisible: commentFieldSelector(state, props)
    };
  };
};

export default connect(makeMapStateToProps)(Component);
